import { Box } from "../../Box";
import { Input } from "../../Input";
import { Text } from "../../Text";
import type { SamlMapping } from "./constants";
import { Field } from "./shared";

const mappingFields: {
  key: keyof SamlMapping;
  label: string;
  required: boolean;
}[] = [
  { key: "email", label: "Email", required: true },
  { key: "firstName", label: "First name", required: true },
  { key: "lastName", label: "Last name", required: true },
  { key: "image", label: "Profile picture", required: false },
];

export function MappingFields({
  mapping,
  onChange,
  placeholder,
  allOptional,
}: {
  mapping: SamlMapping;
  onChange: (mapping: SamlMapping) => void;
  placeholder?: string;
  allOptional?: boolean;
}) {
  return (
    <>
      {mappingFields.map(({ key, label, required: fieldRequired }) => {
        const required = allOptional ? false : fieldRequired;
        return (
          <Field key={key}>
            <Box horizontal={8} vertical={10}>
              <Text variant="text-small-md">
                {required ? label : `${label} (optional)`}
              </Text>
            </Box>
            <Input
              value={mapping[key]}
              onChange={(e) => onChange({ ...mapping, [key]: e.target.value })}
              placeholder={placeholder}
              required={required}
              style={{ width: "100%" }}
            />
          </Field>
        );
      })}
    </>
  );
}
